module.exports = __webpack_public_path__ + "img/ipad_cn.a1ac055.jpg";